import { withApollo } from "react-apollo";
import React from "react";
import DisplayErrors from "../../../Common/DisplayErrors";
import {
  getDefaultPermissionFeatureByIdQuery,
  updatePrivilegeQuery,
} from "../../../../services/graphql/queries/roles";
import { SET_TIMEOUT_VALUE } from "../../../../constants/app-constants";
import SimpleReactValidator from "simple-react-validator";
import SelectComponent from "../../../Common/form-component/SelectComponent";

import close from "../../../../static/images/svg/Close.svg";
class PrivilegeModify extends React.Component {
  constructor() {
    super();

    this.state = {
      errors: [],
      moduleValue: "",
      featureValue: "",
      selectedFeature: {},
      createP: false,
      deleteP: false,
      editP: false,
      viewP: false,
      isSubmitDisable: false,
      defaultPermission: {},
      userType: "",
      userTypes: {
        1: "Admin",
        4: "Info Portal",
      },
    };
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      element: (message) => <div style={{ color: "red" }}>{message}</div>,
    });
    this.submitForm = this.submitForm.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  submitForm(e) {
    var that = this;
    const { selectedFeature, viewP, editP, createP, deleteP } = this.state;
    e.preventDefault();
    this.props.client
      .mutate({
        mutation: updatePrivilegeQuery,
        variables: {
          id: selectedFeature._id,
          viewP: viewP,
          editP: editP,
          createP: createP,
          deleteP: deleteP,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        that.setState({
          isSubmitDisable: false,
        });
        this.props.listMode(true);
        this.props.switchToListMode();
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        that.setState({ isSubmitDisable: false });
        error.graphQLErrors.map(({ message }, i) => {
          that.setState((prevState) => {
            return { errors: [message] };
          });
        });
        setTimeout(() => {
          that.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }

  resetForm() {
    this.setState({
      errors: [],
    });
    this.props.listMode(true);
    this.props.switchToListMode();
  }

  componentDidMount() {
    this.props.client
      .query({
        query: getDefaultPermissionFeatureByIdQuery,
        variables: { id: this.props.selectedRecord.FeatureId._id },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        const user = result.data.getFeaturesById;
        this.initialState = {
          defaultPermission: user,
        };

        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        error.graphQLErrors.map(({ message }, i) => {
          this.setState((prevState) => {
            return { errors: [message] };
          });
        });
      });

    this.setState({
      selectedFeature: this.props.selectedRecord,
      createP: this.props.selectedRecord.createP,
      deleteP: this.props.selectedRecord.deleteP,
      editP: this.props.selectedRecord.editP,
      viewP: this.props.selectedRecord.viewP,
    });
  }
  render() {
    const {
      isSubmitDisable,
      errors,
      selectedFeature,
      defaultPermission,
      userType,
      userTypes,
    } = this.state;
    const { createP, deleteP, editP, viewP } = this.state;
    return (
      <div>
        <div className="row m-b-25 align-items-center">
          <div className="col-md-10">
            <h1 className="heading m-b-0">Modify Privilege</h1>
            <div
              className="row"
              style={{
                display: errors.length === 0 ? "none" : "block",
              }}
            >
              <div className="col-md-6">
                <div className="alert alert-success" role="alert">
                  <div className="row">
                    <DisplayErrors errors={errors} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-2 text-right">
            <a
              href="#"
              className="link-click m-l-45"
              onClick={() => this.props.listMode(true)}
            >
              <img src={close} /> Close
            </a>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="row" style={{ display: "none" }}>
              <div className="col-md-8">
                {/*Alert Section start */}
                <div className="alert alert-success m-b-35" role="alert">
                  Success
                </div>
                {/*Alert Section End */}
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 col-lg-5">
                <div className="form-group">
                  <label>DESCRIPTION</label>
                  <input
                    type="text"
                    className="form-control-plaintext"
                    placeholder="Enter Description"
                    value={
                      selectedFeature.FeatureId &&
                      selectedFeature.FeatureId.description
                        ? selectedFeature.FeatureId.description
                        : ""
                    }
                    readOnly
                  />
                </div>
              </div>

              <div className="col-md-6 col-lg-1">
                <div className="form-group">
                  <label>VIEW</label>
                  <div className="checkbox-style-1">
                    <div className="form-check form-check-inline">
                      {defaultPermission && defaultPermission.enableView ? (
                        <>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox1"
                            value="option1"
                            checked={viewP ? true : false}
                            onChange={(e) => this.setState({ viewP: !viewP })}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineCheckbox1"
                          />
                        </>
                      ) : (
                        <div>NA</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-1">
                <div className="form-group">
                  <label>EDIT</label>
                  <div className="checkbox-style-1">
                    <div className="form-check form-check-inline">
                      {defaultPermission && defaultPermission.enableEdit ? (
                        <>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox2"
                            value="option1"
                            checked={editP ? true : false}
                            onChange={(e) => this.setState({ editP: !editP })}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineCheckbox2"
                          />
                        </>
                      ) : (
                        <div>NA</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-1">
                <div className="form-group">
                  <label>CREATE</label>
                  <div className="checkbox-style-1">
                    <div className="form-check form-check-inline">
                      {defaultPermission && defaultPermission.enableCreate ? (
                        <>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox3"
                            value="option1"
                            checked={createP ? true : false}
                            onChange={(e) =>
                              this.setState({ createP: !createP })
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineCheckbox3"
                          />
                        </>
                      ) : (
                        <div>NA</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-1">
                <div className="form-group">
                  <label style={{ marginLeft: "20px" }}>DELETE</label>
                  <div className="checkbox-style-1">
                    <div className="form-check form-check-inline">
                      {defaultPermission && defaultPermission.enableDelete ? (
                        <>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox4"
                            value="option1"
                            checked={deleteP ? true : false}
                            onChange={(e) =>
                              this.setState({ deleteP: !deleteP })
                            }
                          />
                          <label
                            style={{ marginLeft: "20px" }}
                            className="form-check-label"
                            htmlFor="inlineCheckbox4"
                          />
                        </>
                      ) : (
                        <div style={{ marginLeft: "20px" }}>NA</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                {/* <SelectComponent
                  disabled
                  label={"User Type"}
                  title={"User Type"}
                  name={"userType"}
                  options={userTypes}
                  optionKey={"description"}
                  valueKey={"Id"}
                  value={selectedFeature.userType}
                  placeholder={"Select User Type"}
                  handleChange={this.handleSelect}
                  validator={this.validator}
                  validation="required"
                /> */}

                <div className="form-group">
                  <label>User Type</label>
                  <input
                    type="text"
                    className="form-control-plaintext"
                    placeholder="Enter Description"
                    value={userTypes[selectedFeature.userType]}
                    readOnly
                  />
                </div>
              </div>
              <div className="col-md-12 col-lg-10">
                <div className="row">
                  <div className="col-md-12 ">
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={(e) => this.submitForm(e)}
                      disabled={isSubmitDisable}
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      className="btn btn-light m-l-50"
                      onClick={(e) => this.resetForm(e)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withApollo(PrivilegeModify);
